import * as React from 'react';
import {useTrackingService} from '../../context';
import {useContextTrackingData} from '../../hooks/useContextTrackingData';
import {ActionType} from '../../d6/types';

export type NavUiTrackingProps = Readonly<{
    actionName: ActionType;
    itemCount?: number;
    itemPosition?: number;
    itemId?: string;
}>;

export function useTrackNavUiClick(
    sectionId?: string
): ({actionName, itemCount, itemPosition, itemId}: NavUiTrackingProps) => void {
    const trackingService = useTrackingService();
    const contextTrackingData = useContextTrackingData();
    return React.useCallback(
        ({actionName, itemCount, itemPosition, itemId}: NavUiTrackingProps) => {
            trackingService.trackButtonClick(
                itemId || sectionId || '',
                window.location.pathname,
                actionName,
                {...contextTrackingData, itemCount, itemPosition}
            );
        },
        [contextTrackingData, sectionId, trackingService]
    );
}
